export const universityJson = {
    University_Id: '',
    University_Name: '',
    Country_Id: '0',
    Created_By: '',
    Created_On: '',
    Modified_By: '',
    Modified_On: '',
    Active: '1',
    World_Ranking: '0',
    Country_Ranking: '0',
    University_Address: '',
    Affiliation: '0',
    Affiliation_Pathway: '0',
    Contact_Person: '',
    Contact_Number: '',
    Contact_Email: '',
    Commision_Including_GST: '0',
    Commission_Duration: '0',
    Lumpsum_Commision: '0',
    Attachment_Name: '',
    Commision_Percentage_PG: '0',
    Commision_Percentage_UG: '0',
    Commision_Percentage_Other: '0',
    UniversityImage: '',
    Partnership: '0',
    Logo55x55: '',
    Logo310x125: '',
    Banner1365x700: '',
    Banner275x275: '',
    Banner600x400: ''
}

